// Utility function to check if a page should render.
// For desktop: Is true if the page is the selected page, or adjacent to it.
// For mobile: Is true if the page is selected, adjacent to, or is before the selected page.
// Mobile won't block rendering for prior pages as it messes with scrolling behaviour,
// in that the header will show and hide unnecessarily.
export const checkShouldRender = ({
  selectedPage,
  currentPageIndex,
  isMobile,
}) => {
  const isSelected = selectedPage === currentPageIndex;
  const isAdjacentToSelectedPage =
    selectedPage + 1 === currentPageIndex ||
    selectedPage - 1 === currentPageIndex;
  if (isMobile) {
    const isBeforeSelectedPage = currentPageIndex < selectedPage;
    return isSelected || isAdjacentToSelectedPage || isBeforeSelectedPage;
  } else {
    return isSelected || isAdjacentToSelectedPage;
  }
};
